import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const getAllProducts = (page, limit, categoryId = "") => {
  let url = `${END_POINTS.getAllProducts}?page=${page || 1}&limit=${
    limit || 20
  }`;

  if (categoryId) url += `&categoryId=${categoryId}`;

  return Api(url, null, REQUEST_TYPE.GET);
};

const getProductDetailsByUrl = (url) => {
  return Api(
    `${END_POINTS.getProductDetailsByUrl}/${url}`,
    null,
    REQUEST_TYPE.GET
  );
};

const getRelatedProducts = (url) => {
  return Api(`${END_POINTS.getRelatedProducts}/${url}`, null, REQUEST_TYPE.GET);
};

const addProductReview = (payload) => {
  return Api(END_POINTS.addProductReview, payload, REQUEST_TYPE.POST);
};

const getTopRatedProducts = (url) => {
  return Api(END_POINTS.getTopRatedProducts, null, REQUEST_TYPE.GET);
};

const getAllProductsByCategoryId = (id, subId = "", page = 1, limit = 20) => {
  return Api(
    `${
      END_POINTS.getAllProductsByCategoryId
    }/${id}?page=${page}&limit=${limit}&subCategoryId=${subId || ""}`,
    null,
    REQUEST_TYPE.GET
  );
};

const getSimpleProductsByCategoryId = (
  id,
  subId = "",
  page = 1,
  limit = 20
) => {
  return Api(
    `${
      END_POINTS.getSimpleProducts
    }/${id}?page=${page}&limit=${limit}&subCategoryId=${subId || ""}`,
    null,
    REQUEST_TYPE.GET
  );
};

const getAllSearchedProducts = (search = "", rating = 0, page = 1) => {
  return Api(
    `${END_POINTS.getAllProducts}?page=${page}&search=${search}&rating=${rating}`,
    null,
    REQUEST_TYPE.GET
  );
};

export {
  getAllProducts,
  getProductDetailsByUrl,
  getRelatedProducts,
  addProductReview,
  getTopRatedProducts,
  getAllProductsByCategoryId,
  getAllSearchedProducts,
  getSimpleProductsByCategoryId,
};
